import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classes from './MainSection.module.scss';
import { Skeleton, Typography } from '@mui/material';
const MainSectionSkeleton = () => {
    return (_jsx("div", { className: classes.mainSection, children: _jsxs("div", { className: classes.mainList, children: [_jsx(Typography, { variant: "h3", sx: { width: '25vh', paddingLeft: '20px' }, children: _jsx(Skeleton, { animation: "wave" }) }), Array(4)
                    .fill(0)
                    .map((_, index) => (_jsxs("div", { className: classes.listItems, children: [_jsx(Typography, { variant: "body1", children: _jsx(Skeleton, { animation: "wave" }) }), _jsx(Typography, { variant: "body1", children: _jsx(Skeleton, { animation: "wave" }) })] }, index)))] }) }));
};
export default MainSectionSkeleton;
